export default "__VITE_PUBLIC_ASSET__aff2eab4__"